// extracted by mini-css-extract-plugin
export default {"FlightSearch__inputContainer":"FlightSearch_FlightSearch__inputContainer__Yzc0Z"};